import React, { useEffect, useRef, useState } from 'react';
import styles from './Splash.module.css';

/**
 * Splash Screen – CRYPTMET theme
 * Golden ₵ logo with animated spinner ring
 */
const Splash = ({ onComplete }) => {
  const [isLoading, setIsLoading] = useState(true);
  const splashRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (splashRef.current) {
        splashRef.current.classList.add(styles.fadeOut);
      }
      const cleanup = setTimeout(() => {
        setIsLoading(false);
        onComplete?.();
      }, 500);
      return () => clearTimeout(cleanup);
    }, 2200);

    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!isLoading) return null;

  return (
    <div ref={splashRef} className={styles.splash}>
      {/* Background ambient particles */}
      <div className={styles.bgGlow} />
      <div className={styles.bgGlow2} />

      <div className={styles.container}>
        {/* Spinner ring around logo */}
        <div className={styles.spinnerWrap}>
          {/* Outer rotating ring */}
          <svg className={styles.ringOuter} viewBox="0 0 200 200">
            <defs>
              <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#F5E27A" />
                <stop offset="50%" stopColor="#D4AF37" />
                <stop offset="100%" stopColor="#8B6914" />
              </linearGradient>
            </defs>
            <circle
              cx="100" cy="100" r="90"
              fill="none"
              stroke="url(#goldGrad)"
              strokeWidth="2"
              strokeDasharray="120 40 60 40"
              strokeLinecap="round"
            />
          </svg>

          {/* Inner counter-rotating ring */}
          <svg className={styles.ringInner} viewBox="0 0 200 200">
            <circle
              cx="100" cy="100" r="78"
              fill="none"
              stroke="rgba(212, 175, 55, 0.15)"
              strokeWidth="1"
              strokeDasharray="30 20 10 20"
            />
          </svg>

          {/* Dot accents on the ring */}
          <div className={styles.ringDots}>
            {[0, 60, 120, 180, 240, 300].map((deg) => (
              <span
                key={deg}
                className={styles.ringDot}
                style={{ transform: `rotate(${deg}deg) translateY(-92px)` }}
              />
            ))}
          </div>

          {/* Logo image */}
          <div className={styles.logoContainer}>
            <img
              src="/assets/images/logo/crypt.png"
              alt="CRYPTMET"
              className={styles.logo}
              loading="eager"
            />
          </div>
        </div>

        {/* Loading bar */}
        <div className={styles.loader}>
          <div className={styles.loaderBar}>
            <div className={styles.loaderProgress} />
          </div>
          <span className={styles.loaderText}>CRYPTMET</span>
        </div>
      </div>
    </div>
  );
};

export default Splash;
